import { useRef } from 'react';
import clsx from 'clsx';

import type { Category } from 'src/types/types';
import { Container } from 'src/components/Container/Container';

import styles from './styles.module.scss';

type CategoryNavProps = {
  categories: Category[];
  activeId: string;
  scrolled: boolean;
  onSelectCategory: (id: string) => void;
  secondary?: boolean;
};

export const CategoryNav = ({
  categories,
  activeId,
  scrolled,
  onSelectCategory,
  secondary = false,
}: CategoryNavProps) => {
  const navRef = useRef<HTMLUListElement>(null);

  const handleClick = (id: string) => {
    onSelectCategory(id);

    const btn = navRef.current?.querySelector<HTMLElement>(`[data-id="${id}"]`);
    btn?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  };

  return (
    <div
      className={clsx(
        styles.wrapper,
        scrolled && styles.wrapperScrolled,
        secondary && styles.wrapperSecondary,
      )}
    >
      <Container>
        <nav>
          <ul className={styles.list} ref={navRef}>
            {categories.map((cat) => (
              <li key={cat.id}>
                <button
                  data-id={cat.id}
                  className={clsx(
                    styles.button,
                    activeId === cat.id &&
                      (secondary
                        ? styles.buttonActiveSecondary
                        : styles.buttonActive),
                  )}
                  onClick={() => handleClick(cat.id)}
                >
                  {cat.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </Container>
    </div>
  );
};
